import { ReactComponent as Arrow } from '../../../assets/icons/left_arrow.svg';
import { formatAnswerSheetQuestionNo, getAnswerFilesDisplay, hasAnswerContent } from '../../../assets/utils/utils';
import sheet from '../../../styles/components/answerSheet.module.scss';

import btnClasses from '../../../styles/components/uploadButtons.module.scss';

const PreviewUploadButtons = ({ index, quNo, score, activeBtn, isInfo, userAnswered, onQuestionClick }) => {
    const getAnswerForQuestion = () => {
        if (!userAnswered) return null;
        for (let i = 0; i < userAnswered.length; i++) {
            if (index === userAnswered[i]?.id) {
                return userAnswered[i];
            }
        }
        return null;
    };

    const answerData = getAnswerForQuestion();
    const isAnswered = hasAnswerContent(answerData);
    const buttonText = isAnswered
        ? (getAnswerFilesDisplay(answerData) || "پاسخ ثبت شده")
        : "پاسخ ثبت نشده";

    const handleClick = () => {
        if (onQuestionClick && answerData) {
            onQuestionClick({ quNo, ...answerData });
        }
    };

    return (
        <li key={index} className={btnClasses.uploadButtonRow} style={{ paddingRight: 0 }}>
            <div className={sheet.sheetRow}>
                <span className={sheet.questionNo}>{formatAnswerSheetQuestionNo(quNo)}</span>
                <div className={`${sheet.descriptiveBtnWrap} ${btnClasses.uploadBtn_container} ${activeBtn === index && btnClasses.active_uploadBtn} ${isAnswered && btnClasses.successUpload}`}
                    onClick={handleClick}
                    style={{ cursor: answerData ? 'pointer' : 'default', width: '100%', maxWidth: '100%' }}
                >
                    <p className={`${btnClasses.uploadBtn} uploadBtn-${index}`}>{buttonText}</p>
                    <Arrow className={`${btnClasses.arrow} ${activeBtn === index && btnClasses.active_arrow}`} />
                </div>
                <div className={sheet.gradeCol}>
                    <span className={sheet.gradeValue}>{score}</span>
                    <span className={sheet.gradeLabel}>بارم</span>
                </div>
            </div>
        </li>
    );
};

export default PreviewUploadButtons;
